import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  dispaly: '',
  label: '',
  value: '',
  code: '',
  raw: {},
  componentName: '',
};

const quickAddDataSlice = createSlice({
  name: 'quickAddDataSlice',
  initialState,
  reducers: {
    quickAddData: (state, action) => {
      return { ...state, ...action?.payload };
    },
    componentName: (state, action) => {
      return { ...state, ...action?.payload };
    },
  },
});

export const { quickAddData, componentName } = quickAddDataSlice.actions;
export default quickAddDataSlice.reducer;
